<template>
    <div class="header">
        <layout>
            <Header :style="{backgroundColor: '#fff',height: '60px'}">
                <Menu mode="horizontal" theme="light" :active-name="0" :style="headerStyle">
                    <div class="headerLogoWrapper">
                        <img class="headerLogo" :src="topUrl.headerLogo"/>
                        <div class="headerSquare"></div>
                        <div class="headerTitle">{{lang('headerTitle',language)}}</div>
                    </div>
                    <div :style="{float:'left',marginLeft:'15px',marginTop:'-5px'}">beta</div>
                    <div v-if="userInfo !== null" :style="{float: 'right',width:'170px'}">
                        <div :style="{float:'left',width: '75px',overflow: 'hidden',textOverflow: 'ellipsis',whiteSpace: 'nowrap'}">
                            {{userInfo.userName}}
                        </div>
                        <a @click="logout" :style="{marginLeft: '30px'}">{{lang('loginOutText',language)}}</a>
                    </div>
                    <div class="headerLinkWrapper">
                        <MenuItem v-for="(item,index) in headerLinkArr" :key="index" :name="index" :to="item.url" :target="item.isBlank">
                            {{item.title}}
                        </MenuItem>
                    </div>
                    <!-- <div class="headerLangSelectWrapper">
                         <Dropdown @on-click="changeLang">
                             <a href="javascript:void(0)" >
                                 {{currentLang}}
                                 <Icon type="ios-arrow-down"></Icon>
                             </a>
                             <DropdownMenu slot="list" >
                                 <DropdownItem name='zh'>简体中文</DropdownItem>
                                 <DropdownItem name='en'>English</DropdownItem>
                             </DropdownMenu>
                         </Dropdown>
                     </div>-->
                </Menu>

            </Header>
        </layout>
    </div>
</template>

<script>
    import {lang} from "@/utils/language.js";
    import store from '@/store/index.js';
    import config from "@/utils/config.js";

    export default {
        name: "Top",
        store,
        data() {
            return {
                lang: lang,
                topUrl: {
                    headerLogo: require('@/assets/logo.png'),
                },
                headerLinkArr: [],
                currentLang: '',
                stateLang: '',
                defaultAvatar: config.defaultAvatar,
            }
        },
        mounted() {
            this.currentLang = '简体中文';
            this.loadHeaderLink();
        },
        methods: {
            loadHeaderLink() {
                this.headerLinkArr.splice(0);
                for (var i = 1; i <= 3; i++) {
                    var item = {};
                    if (i !== 1) {
                        item.isBlank = '_blank';
                    }
                    item.url = config['headerLink' + i];
                    item.title = this.lang('headerLinkTitle' + i, this.language);
                    if (JSON.stringify(item) !== '') {
                        this.headerLinkArr.push(item);
                    }
                }
            },
            changeLang(lang) {
                store.commit("changeLang", lang);
                switch (lang) {
                    case 'zh':
                        this.currentLang = '简体中文';
                        break;
                    case 'en':
                        this.currentLang = 'English';
                        break;
                }
            },
            logout() {
                store.commit('removeUserInfo');
                store.commit('removeScope');
                this.$router.push('/login');
            },
        },
        computed: {
            language: function () {
                this.stateLang = store.state.lang;
                return store.state.lang;
            },
            headerStyle: function () {
                return {
                    width: '100%',
                    maxWidth: '1080px',
                    height: '60px',
                    marginLeft: 'auto',
                    marginRight: 'auto'
                }
            },
            userInfo: function () {
                return store.getters.getUser;
            }
        },
        watch: {
            stateLang: function () {
                this.loadHeaderLink()
            },
        },


    }
</script>

<style scoped>
    .headerLogoWrapper {
        float: left;
        margin-top: 5px;
    }

    .headerLinkWrapper {
        float: right;
        margin-right: 50px;
    }

    .headerLangSelectWrapper {
        float: left;
        position: relative;
        left: 110px;
    }

    .headerLogo {
        height: 25px;
        width: 150px;
    }

    .headerSquare {
        position: relative;
        top: 2px;
        left: 10px;
        width: 1px;
        height: 30px;
        background: #00AAE8;
        display: inline-block;
    }

    .headerTitle {
        position: relative;
        left: 15px;
        bottom: 4px;
        font-family: MicrosoftYaHei;
        font-size: 24px;
        color: #2F2F2F;
        display: inline-block;
    }


</style>
